import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
const clipLoader = "clip-loader-module_clipLoader_yelSH";
const style$1 = {
  clipLoader,
  "ClipLoader-clip": "clip-loader-module_ClipLoader-clip_-GNsC"
};
const ClipLoader$1 = () => {
  return /* @__PURE__ */ jsx("span", { className: style$1.clipLoader });
};
const ClipLoader = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(ClipLoader$1, { ref, className: classNames("sa-loader", className), ...props });
});
ClipLoader.displayName = "ClipLoader";
const pulseLoader = "pulse-loader-module_pulseLoader_-yp5k";
const item_1 = "pulse-loader-module_item_1_0I96L";
const item_2 = "pulse-loader-module_item_2_2Vttr";
const item_3 = "pulse-loader-module_item_3_njzq8";
const size_4 = "pulse-loader-module_size_4_97qGV";
const style = {
  pulseLoader,
  item_1,
  "PulseLoader-pulse": "pulse-loader-module_PulseLoader-pulse_J0pNC",
  item_2,
  item_3,
  size_4
};
const PulseLoader$1 = ({ size = 4 }) => {
  return /* @__PURE__ */ jsx("span", { children: [1, 2, 3].map((itemNum) => /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames(
        style.pulseLoader,
        style[`size_${size}`],
        style[`item_${itemNum}`]
      )
    }
  )) });
};
const PulseLoader = React.forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(PulseLoader$1, { ref, className: classNames("sa-loader", className), ...props });
});
PulseLoader.displayName = "PulseLoader";
export {
  ClipLoader as C,
  PulseLoader as P
};
